import { jsx as _jsx } from "react/jsx-runtime";
import useRewards from '../../../../../hooks/useRewards';
import ModalDrawerHeader from '../../molecules/ModalDrawerHeader';
var ModalHeader = function () {
    var accountSummary = useRewards().accountSummary;
    return accountSummary ? (_jsx(ModalDrawerHeader, { accountSummary: accountSummary })) : null;
};
export default ModalHeader;
